module.exports = __webpack_public_path__ + "static/img/checkMark copy.2acbef2.png";